import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAnalytics } from './use-analytics';

const useRouterAnalytics = () => {
  const { logEvent } = useAnalytics();
  const location = useLocation();
  useEffect(() => {
    logEvent('page_view', {
      page_title: document.title,
      page_location: location.pathname,
      language: navigator.language,
    });
  }, [location, logEvent]);
};

export { useRouterAnalytics };
